module.exports = __webpack_public_path__ + "static/media/mov_bbb.198918f4.mp4";